<template>
  <div class="home">
    <school-home v-if="orgType === 2"></school-home>
    <area-home v-else></area-home>
  </div>
</template>

<script>
import { getStorage } from "@/common/js/localstorage";
import SchoolHome from "@/components/SchoolHome"
import AreaHome from "@/components/AreaHome"

export default {
  name: "Home",
  data() {
    return {
      orgType: getStorage('school').org_type || 2
    }
  },
  components: {
    SchoolHome,
    AreaHome
  }
}
</script>

<style scoped lang="stylus">
.lunbo-img {
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.mar-left {
  margin-left: 10px;
}

.click-box {
  cursor: pointer;

  .video-img {
    position: relative;
    overflow: hidden;
    transition: opacity 0.3s;
    -moz-transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    -o-transition: opacity 0.3s;

    .poster {
      height: 100%;
      width: 100%;
      transition: all 0.6s;
    }

    .video-tag {
      font-size: 14px;
    }

    .video-play-bg {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      opacity: 0;
      visibility: hidden;
    }
  }
}

.click-box:hover {
  .video-img .poster {
    transform: scale(1.1);
  }

  /deep/ .video-img .video-play-bg {
    visibility: visible !important;
    opacity: 1 !important;
  }
}

.title {
  width: 100%;
  height: 42px;
  line-height: 42px;
  font-size: 30px;
  text-align: left;
  display: flex;
  align-items: center;
  border-left: 4px solid #569AF8;
  padding-left: 20px;
  font-weight: 500;

  .el-link {
    height: 27px;
    width: 55px;
    line-height: 27px;
    border-radius: 27px;
    text-align: center;
    margin-left: 40px;
    border: 1px solid #E4E7ED;
    padding-left: 5px;
  }

  .el-link:hover {
    border-color: #569AF8;
    color: #569AF8;
  }
}

.top {
  height: 25vw;
  width: 100%;
  min-height: 290px;
  position: relative;
  margin-top: 6.5vh;

  .live-box {
    width: 80%;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .live-list {
      width: 100%;
      height: 13.8vw;
      margin-top: 40px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;

      .video {
        width: 19%;
        height: 100%;
        min-width: 200px;
        margin: auto 0.8%;
        display: inline-block;
        border-radius: 3px;
        overflow: hidden;

        a {
          text-decoration: none;
          color: black;
        }

        .video-img {
          width: 100%;
          height: 8.8vw;
          min-height: 117px;

          span {
            color: white;
            position: absolute;
            right: 0;
            padding: 0.2rem 0.5rem;
            border-radius: 0 3px;
          }

          .video-tag {
            font-size: 14px;
          }

          .viewer {
            width: 100%;
            height: 20%;
            position: absolute;
            bottom: 0;
            background: rgba(0, 0, 0, 0.3);
            text-align: left;
            display: flex;
            font-size: 14px;
            align-items: center;
            color: white;
            padding-left: 0.5rem;
            box-sizing: border-box;
          }
        }

        .video-name {
          width: 100%;
          height: 2.5vw;
          min-height: 24px;
          white-space: nowrap;
          padding-left: 2px;
          box-sizing: border-box;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 16px;
          font-weight: 500;
          text-align: left;
          display: flex;
          align-items: center;
        }

        .video-detail {
          height: 2vw;
          font-size: 14px;
          color: #909399;
          position: relative;

          span:nth-of-type(1) {
            position: absolute;
            top: 0;
            left: 2px;
          }

          span:nth-of-type(2) {
            position: absolute;
            top: 0;
            right: 0.5rem;
          }
        }

        @media screen and (max-width: 1080px) {
          .video-img {
            .viewer {
              font-size: 14px;
            }
          }

          .video-name {
            font-size: 18px;
          }

          .video-detail {
            font-size: 12px;
          }
        }
      }
    }

    @media screen and (max-width: 1075px) {
      .live-list {
        min-height: 201px;
        padding-bottom: 10px;
        overflow-x: auto;
      }
    }
  }
}

.middle {
  height: 30vw;
  min-height: 345px;
  width: 100%;
  background: url('~@/common/img/banner2.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;

  .ranking-list {
    width: 30%;
    height: 100%;
    padding-top: 3vh;
    margin-right: 10%;
    box-sizing: border-box;
  }

  @media screen and (max-width: 900px) {
    .notice {
      display: none;
    }

    .ranking-list {
      width: 70%;
    }
  }

  .notice {
    width: 40%;
    height: 100%;
    padding-top: 3vh;
    box-sizing: border-box;
  }
}

.bottom {
  height: 34.2vw;
  width: 100%;
  min-height: 390px;
  display: flex;
  justify-content: center;
  margin-top: 6.5vh;

  .resource-box {
    height: 100%;
    width: 80%;

    .left-box {
      width: 40%;
      height: 27vw;
      min-width: 340px;
      min-height: 270px;
      margin-top: 40px;
      display: inline-block;
      position: relative;

      .first-resource {
        width: 100%;
        height: 100%;
        border-radius: 3px;
        overflow: hidden;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        .click-box {
          height: 100%;
          background-color: #f8f8f8;
        }

        a {
          text-decoration: none;
          color: black;
        }

        .video-img {
          width: 100%;
          height: 18vw;
          min-height: 194px;
        }

        .video-name {
          width: 100%;
          height: 4vw;
          min-height: 43px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 24px;
          font-weight: 500;
          text-align: left;
          padding-left: 0.5rem;
          box-sizing: border-box;
          display: flex;
          align-items: center;
        }

        .video-detail {
          width: 100%;
          height: 3vw;
          font-size: 14px;
          color: #999999;
          position: relative;
          text-align: left;
          padding-left: 0.5rem;

          .video-detail-owner {
            margin-bottom: 30px;
          }

          .btn-box {
            text-align: left;

            .el-link--default {
              cursor: text;
              color: #999999;
            }
          }
        }

        @media screen and (max-width: 1080px) {
          .video-name {
            font-size: 18px;
          }

          .video-detail {
            font-size: 14px;

            .btn-box {
              width: 70%;

              .el-link--default {
                font-size: 14px !important;
              }
            }
          }
        }
      }
    }

    .right-box {
      width: 60%;
      height: 27vw;
      min-width: 510px;
      min-height: 270px;
      margin-top: 40px;
      display: inline-block;
      position: relative;

      .other-resource {
        width: 100%;
        height: 100%;
        display: flex;
        box-sizing: border-box;
        flex-direction: column;
        align-items: flex-end;
        justify-content: space-between;
        flex-wrap: wrap;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        .video {
          width: 14.4vw;
          height: 13.1vw;
          min-width: 155px;
          min-height: 130px;
          border-radius: 3px;
          overflow: hidden;

          a {
            text-decoration: none;
            color: black;
          }

          .video-img {
            width: 100%;
            height: 8.5vw;
            min-height: 87px;

            .button-box {
              width: 100%;
              height: 18%;
              position: absolute;
              bottom: 0;
              text-align: left;
              padding-left: 10px;

              .el-link--default {
                font-size: 14px;
                color: white;
              }
            }
          }

          .video-name {
            width: 100%;
            height: 2.4vw;
            min-height: 21px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 16px;
            text-align: left;
            padding-left: 0.5rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
          }

          .video-detail {
            width: 100%;
            height: 2vw;
            color: #999999;
            padding-left: 0.5rem;
            position: relative;

            .video-detail-owner {
              font-size: 14px;
              text-align: left;
            }
          }

          @media screen and (max-width: 1080px) {
            .video-name {
              font-size: 14px;
            }

            .video-img {
              .el-link--default {
                font-size: 12px !important;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  .middle {
    background-size: auto 100%;
  }
}
</style>
